import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  container: {
    maxWidth: "640px",
  },
  imageStyles: {
    width: "80px",
    height: "60px",
  },
  titleStyles: {
    marginLeft: theme.spacing(2),
  },
  row: {
    marginTop: theme.spacing(5),
  },
  settingsText: {
    fontWeight: 400,
  },
  checkboxContainer: {
    paddingLeft: "0px",
    paddingRight: "4px",
  },
  checkboxText: {
    fontSize: "14px",
    fontWeight: 700,
    lineHeight: "16px",
    cursor: "pointer",
  },
  descriptionText: {
    marginLeft: "28px",
  },
}));

export default useStyles;
